'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCC = exports.getBCC = exports.getToAddresses = exports.getStatus = exports.getAttachments = exports.getFromAddress = exports.getSubject = exports.getRichText = exports.getPlainText = exports.getConnectedAccountAddress = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _keyPaths = require('../constants/keyPaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getConnectedAccountAddress = exports.getConnectedAccountAddress = (0, _getIn2.default)(_keyPaths.CONNECTED_ACCOUNT_ADDRESS);

var getPlainText = exports.getPlainText = (0, _getIn2.default)(_keyPaths.PLAIN_TEXT);

var getRichText = exports.getRichText = (0, _getIn2.default)(_keyPaths.RICH_TEXT);

var getSubject = exports.getSubject = (0, _getIn2.default)(_keyPaths.SUBJECT);

var getFromAddress = exports.getFromAddress = (0, _getIn2.default)(_keyPaths.FROM_EMAIL);

var getAttachments = exports.getAttachments = (0, _getIn2.default)(_keyPaths.ATTACHMENTS);

var getStatus = exports.getStatus = (0, _getIn2.default)(_keyPaths.STATUS);

var getToAddresses = exports.getToAddresses = (0, _getIn2.default)(_keyPaths.TO);

var getBCC = exports.getBCC = (0, _getIn2.default)(_keyPaths.BCC);

var getCC = exports.getCC = (0, _getIn2.default)(_keyPaths.CC);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/email-message-metadata/operators/emailMessageMetadataGetters.js
// module id = 693
// module chunks = 2 3